import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { IEftInfo } from "../../classes/Domain";

const VALIDATION = {
    INVALID_EFT_TRANSIT_NUMBER: "Eft transit number is invalid",
    INVALID_EFT_ACCOUNT_NUMBER: "Eft account number is invalid",
};

const rules = {
    installmentInstrument: {
        bankName: 'required',
        transitNumber: ['required', 'valid_eft_transit_number'],
        accountNumber: ['required', 'valid_eft_account_number']
    }
};

const customErrorMessages = {
    "valid_eft_transit_number": VALIDATION.INVALID_EFT_TRANSIT_NUMBER,
    "valid_eft_account_number": VALIDATION.INVALID_EFT_ACCOUNT_NUMBER,
};

export const allFieldsValidation = (data: { installmentInstrument: IEftInfo }) => {
    return allFieldsValidationCommon(data, rules, { ...customErrorMessagesCommon, ...customErrorMessages });
};